import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import { missingPartsOptions1 } from '../../../constants/constants';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import { IAddTray, IUpdateTray } from '../../../models/forms/IAddUpdateTray';
import { IFormModalProps } from '../../../models/forms/IForm';
import DefaultModal from '../../../shared-components/modal/default-modal';
import { formatMessage } from '../../../translations/format-message';
import AddEditTrayManagementForm from '../forms/add-edit-tray-management-form';

const AddEditTrayManagement = (props: IFormModalProps) => {
  const { trayManagementStore, productStore } = useStore();

  const {
    AddTrayService,
    UpdateTrayService,
    GetTrayByIdService,
    resetAddUpdateTrayState,
    resetTrayDetail,
    addUpdateTrayState,
    trayDetails,
  } = trayManagementStore;

  const initialValues = trayDetails;

  const {
    GetProductByIdService,
    GetAllProductService,
    getAllProductState,
    allProductReactSelectOptions,
  } = productStore;
  /**
   * The useEffect Hook lets you perform side effects in function component.
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered
   * while a dependency of the useEffect has changed.
   */
  useEffect(() => {
    GetAllProductService(Number(getTenantIdFromLocalStorage()));
    if (props.id > 0) {
      GetTrayByIdService(Number(getTenantIdFromLocalStorage()), props.id);
    }
  }, []);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessSuccess" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateTrayState.success) {
      if (props.id === -1) toast.success(formatMessage('added_success'));
      else toast.success(formatMessage('updated_success'));
      onModalClosed();
    }
  }, [addUpdateTrayState.success]);

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateProcessError" of the useEffect changed.
   */
  useEffect(() => {
    if (addUpdateTrayState.error) {
      toast.error(formatMessage(addUpdateTrayState.error));
      resetAddUpdateTrayState();
    }
  }, [addUpdateTrayState.error]);

  /**
   * This function adds the Process when "Id < 0" and updates the Existing Process when Id > 0 by providing form values to the
   * correponding function
   */
  const onSubmitForm = ({
    TrayId,
    CustomerId,
    EndUserName,
    EndUserOrderId,
    OrderId,
    SubContractor,
    SubContractorName,
    ProductId,
    Katashiki1,
    Katashiki2,
    Kishu,
    ProcessName,
    Quantity,
    InvoiceNumber,
    QuantityUnitName,
    CustomerDueDate,
    MissingParts,
    Group,
    ProductComment1,
    ProductComment2,
    ProductComment3,
    ProductComment4,
    ProductComment5,
    ProductComment6,
    CurrentState,
    Remarks,
    ProductName
  }) => {
    var addObj: IAddTray = {
      TrayId: TrayId.trim(),
      CustomerId,
      EndUserName,
      EndUserOrderId,
      OrderId,
      SubContractor: SubContractor || 0,
      SubContractorName,
      ProductId,
      Katashiki1: Katashiki1.trim(),
      Katashiki2: Katashiki2.trim(),
      Kishu: Kishu.trim(),
      ProcessName,
      Quantity: Quantity || 0,
      InvoiceNumber: InvoiceNumber || 0,
      QuantityUnitName,
      CustomerDueDate,
      MissingParts: MissingParts.trim(),
      Group,
      ProductComment1,
      ProductComment2,
      ProductComment3,
      ProductComment4,
      ProductComment5,
      ProductComment6,
      CurrentState,
      Remarks,
      TenantId: Number(getTenantIdFromLocalStorage()),
      ProductName
    };

    var updateObj: IUpdateTray = {
      Id: props.id,
      CustomerId: CustomerId || '0',
      OrderId,
      Kishu: Kishu.trim(),
      EndUserOrderId,
      MissingParts: MissingParts.trim(),
      Group,
      CurrentState,
      Remarks,
      EndUserName,
      SubContractor: SubContractor || 0,
      SubContractorName,
      Katashiki1: Katashiki1.trim(),
      Katashiki2: Katashiki2,
      ProcessName,
      Quantity: Quantity || 0,
      InvoiceNumber: InvoiceNumber || 0,
      QuantityUnitName,
      ProductComment1,
      ProductComment2,
      ProductComment3,
      ProductComment4,
      ProductComment5,
      ProductComment6,
      CustomerDueDate,
      TenantId: Number(getTenantIdFromLocalStorage()),
      ProductId: ProductId,
      TrayId: TrayId.trim(),
    };

    if (props.id < 0) {
      AddTrayService(addObj);
    } else {
      UpdateTrayService(updateObj);
    }
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    resetTrayDetail();
    props.modalClosed();
  };

  const getProductByIdServiceHandler = (productId: number) => {
    GetProductByIdService(Number(getTenantIdFromLocalStorage()), productId);
  };

  return (
    <React.Fragment>
      <DefaultModal
        id={props.id}
        className=""
        addHeader="add_tray"
        updateHeader="update_tray"
        onModalClosed={onModalClosed}
        isLoading={
          addUpdateTrayState.inProgress || getAllProductState.inProgress
        }
        size="lg"
      >
        <AddEditTrayManagementForm
          id={props.id}
          initialValues={initialValues}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={
            addUpdateTrayState.inProgress || getAllProductState.inProgress
          }
          allProductOptions={allProductReactSelectOptions}
          getProductByIdServiceHandler={getProductByIdServiceHandler}
          missingOptions={missingPartsOptions1.map((item) => {
            if (item.value === '-1')
              return { ...item, label: formatMessage(item.label) };
            else return { ...item };
          })}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(AddEditTrayManagement);
